import UsernameFormModel from './model/form.model.js';
import { success } from '@shared/ui/utils/toastr';

class UsernameController {
	constructor(ProfileStore, SecurityApiService, $translate) {
		'ngInject';

		this.SecurityApiService = SecurityApiService;
		this.ProfileStore = ProfileStore;
		this.$translate = $translate;
	}

	$onInit() {
		this.form = new UsernameFormModel();

		this.ProfileStore.getProfile().then((profile) => {
			this.form.currentUsername = profile.user.username;
		});
	}

	submit() {
		this.SecurityApiService.saveCredentials(this.form.toPayload())
			.then(() => {
				success(this.$translate.instant('Account username has been successfully updated!'));
				this.form.currentUsername = this.form.newUsername;
				this.form.reset();
			})
			.catch((errors) => {
				this.form.setFormErrors(errors);
			})
		;
	}
}

export default UsernameController;



// WEBPACK FOOTER //
// ./client/app/pages/settings/component/username/username.controller.js